export default __webpack_public_path__ + "static/media/img-0141-germany-premium-face.60c36a09.png";